import { Navigate } from "react-router-dom";
import { permissionService } from "../auth/permissionService";
import { useAuth } from "../auth/AuthContext";

export default function LandingPage() {

  const { loading } = useAuth();

  if (loading) return null;

  const route = permissionService.getDefaultAccessibleRoute();

  console.log(route)

  if (!route) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Navigate to={route} replace />;
}